import type { ColumnModel, DialectId, SchemaModel, TableModel } from '@bits2schema/shared';
import { randomId } from '../command/types';
import { nextColumnName, nextTableName } from './mutations';

/**
 * Výchozí PK sloupec nové tabulky (epic-4 kap. 9, otevřená otázka —
 * pragmatická volba, nemění architekturu): `id` s typem, který je v
 * typovém katalogu obou MVP dialektů vždy rozpoznaný.
 */
function defaultPrimaryKeyColumn(dialect: DialectId): ColumnModel {
  const rawType = dialect === 'postgresql' ? 'bigserial' : 'BIGINT';
  return {
    id: randomId(),
    name: 'id',
    ordinal: 1,
    rawType,
    canonicalType: rawType,
    isTypeRecognized: true,
    nullable: false,
    defaultValue: null,
    comment: null,
  };
}

/** E4-US4 — nový sloupec se zakládá s textovým typem, ihned editovatelným. */
export function createDefaultColumn(table: TableModel, dialect: DialectId): ColumnModel {
  const rawType = dialect === 'postgresql' ? 'text' : 'VARCHAR';
  return {
    id: randomId(),
    name: nextColumnName(table),
    ordinal: table.columns.length + 1,
    rawType,
    canonicalType: rawType,
    isTypeRecognized: true,
    nullable: true,
    defaultValue: null,
    comment: null,
  };
}

/** E4-US1 — nová tabulka se zakládá s navrhovaným PK sloupcem, ihned editovatelným/odebratelným. */
export function createDefaultTable(schema: SchemaModel): TableModel {
  const dbSchema = schema.schemas[0] ?? 'public';
  const column = defaultPrimaryKeyColumn(schema.dialect);
  return {
    id: randomId(),
    name: nextTableName(schema, dbSchema),
    schema: dbSchema,
    comment: null,
    columns: [column],
    primaryKey: { name: null, columns: [column.name] },
    foreignKeys: [],
    uniqueConstraints: [],
    checkConstraints: [],
    indexes: [],
  };
}
